import React, { useState, useEffect } from 'react';
import './FavoritesPremium.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import axios from 'axios';
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";

const Favorites = ({ favId, token, onDelete }) => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [showLogin, setShowLogin] = useState(false);     // Line 331
  const [cartItems, setCartItems] = useState([]);        // Line 359
  const [isModalOpen, setIsModalOpen] = useState(false); // Line 374 & 377
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  // Line 376
  useEffect(() => {
    const fetchFavorites = async () => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken");
      const vendorid = localStorage.getItem("vendorId"); 
      // <-- AUTH TOKEN
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          ` https://backend.maamaas.com/food/api/favourite/getallbyuserid/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        const data = await response.json();
        setFavorites(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  const handleViewCartClick = () => {
  setIsModalOpen(false);

  const vendorid = localStorage.getItem("vendorId");

  if (!vendorid) {
    console.log("Vendor ID missing");
    return;
  }

  navigate(`/Tablemainfile/${vendorid}`);
};

  const addToCart = async (item, quantity = 1) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      setShowLogin(true);
      return;
    }

    if (!token) {
      alert("Please log in to add items to cart.");
      return;
    }

    // Using the correct API endpoint format
    const addItemUrl = `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}`;
    const data = {
      dishId: item.dishId,
      quantity: quantity,
    };

    try {
      const response = await axios.post(addItemUrl, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        // Update local state
        setQuantities((prev) => ({
          ...prev,
          [item.dishId]: (prev[item.dishId] || 0) + quantity,
        }));

        setCartItems((prevItems) => {
          const existingItem = prevItems.find(
            (cartItem) => cartItem.dishId === item.dishId
          );
          if (existingItem) {
            return prevItems.map((cartItem) =>
              cartItem.dishId === item.dishId
                ? { ...cartItem, quantity: (cartItem.quantity || 0) + quantity }
                : cartItem
            );
          } else {
            return [...prevItems, { ...item, quantity }];
          }
        });

        setIsModalOpen(true);
        setTimeout(() => {
          if (!isHovered) {
            setIsModalOpen(false);
          }
        }, 2000);
      }
    } catch (error) {
      console.error("❌ Error adding item to cart:", error);
      if (error.response?.status === 500) {
        alert("Server error. Please try again later.");
      } else if (error.response?.status === 401) {
        alert("Session expired. Please login again.");
        setShowLogin(true);
      } else {
        alert("Failed to add item to cart. Please try again.");
      }
    }
  };
  const updateCartQuantity = async (userId, token, dishId, quantity) => {
    const url = `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&dishId=${dishId}&quantity=${quantity}`;

    try {
      const response = await axios.put(url, {}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.status === 200;
    } catch (error) {
      console.error("❌ Error updating cart:", error);
      return false;
    }
  };

  const increaseQuantity = async (dishId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    const item = cartItems.find(i => i.dishId === dishId);
    const newQty = (item?.quantity || 0) + 1;

    const success = await updateCartQuantity(userId, token, dishId, newQty);

    if (success) {
      setCartItems(prev =>
        prev.map(i =>
          i.dishId === dishId ? { ...i, quantity: newQty } : i
        )
      );
    }
  };

  const decreaseQuantity = async (dishId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    const item = cartItems.find(i => i.dishId === dishId);
    const currentQty = item?.quantity || 1;

    if (currentQty <= 1) return;

    const newQty = currentQty - 1;

    const success = await updateCartQuantity(userId, token, dishId, newQty);

    if (success) {
      setCartItems(prev =>
        prev.map(i =>
          i.dishId === dishId ? { ...i, quantity: newQty } : i
        )
      );
    }
  };


 const handleDeleteFavourite = async (favId) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    console.log("User not authenticated");
    return;
  }

  try {
    await axios.delete(
      `https://backend.maamaas.com/food/api/favourite/delete/${favId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );

    // Remove the deleted item from the favorites state (auto refresh)
    setFavorites(prevFavorites => prevFavorites.filter(item => item.favId !== favId));

  } catch (error) {
    console.error("Delete failed:", error);
    
    if (error.response?.status === 403) {
      console.log("You are not authorized to delete this favourite.");
    } else {
      console.log("Failed to delete favourite. Please try again.");
    }
  }
};








  return (
    <div className="favorites-container">
      {loading ? (
        <div>Loading...</div>
      ) : (
        favorites.map((item) => (
          <div key={item.dishId} className="favorites-card">
            <div className="favorites-inner-box">
              <img
                src={item.dishImage || "default-image.jpg"}
                alt="Dish"
                className="offer-image"
              />
            </div>

            <div className="favorites-card-body">
              <h5 className="favorites-card-title">{item.dishName}</h5>

              <div className="price-row">
                <span className="new-price">
                  ₹{item.price.toFixed(2)}
                </span>
                <span className="old-price">₹{item.price}</span>
                <i
                  className="fa-solid fa-heart"
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => handleDeleteFavourite(item.favId)}
                ></i>

              </div>

              {quantities[item.dishId] > 0 ? (
                <div className="qty-box">
                  <button
                    onClick={() => {
                      decreaseQuantity(item.dishId);
                      addToCart(item, quantities[item.dishId] - 1);
                    }}
                  >
                    -
                  </button>

                  <span className="qty-value">{quantities[item.dishId]}</span>

                  <button
                    onClick={() => {
                      increaseQuantity(item.dishId);
                      addToCart(item, quantities[item.dishId] + 1);
                    }}
                  >
                    +
                  </button>
                </div>
              ) : (
                <button
                  className="add-btn"
                  onClick={() => {
                    setQuantities((prev) => ({ ...prev, [item.dishId]: 1 }));
                    addToCart(item, 1);

                    // ✅ OPEN THIS MODAL
                    setIsModalOpen(true);
                  }}
                >
                  Add To Cart
                </button>




              )}
            </div>
            <Modal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
              shouldCloseOnOverlayClick={false}
              shouldCloseOnEsc={false}
              style={{
                overlay: {
                  backgroundColor: "transparent",
                  pointerEvents: "none",
                },
                content: {
                  pointerEvents: "auto",
                  position: "absolute",
                  top: "92%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "80%",
                  maxWidth: "500px",
                  border: "none",
                  padding: "0px",
                  height: "90px",
                  borderRadius: "16px",
                  background: "transparent",
                  overflow: "visible",
                },
              }}
            >
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 24px",
                height: "85px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #ffffff 0%, #f9f5ff 100%)",
                boxShadow: "0 8px 25px rgba(177, 92, 214, 0.2)",
              }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <ShoppingCart style={{ fontSize: "32px", color: "#ee6521", marginRight: "18px" }} />
                  <div style={{ fontSize: "22px", fontWeight: "700", color: "#5a2d69" }}>
                    ({cartItems.reduce((a, i) => a + (quantities[i.dishId] || 0), 0)}) Items
                  </div>
                </div>

                <div style={{ fontSize: "22px", fontWeight: "700", color: "#5a2d69" }}>
                  Total ₹
                  {cartItems
                    .reduce((total, item) => {
                      return total + (parseFloat(item.price) || 0) * (item.quantity || 1);
                    }, 0)
                    .toFixed(1)}
                </div>

                <button
                  onClick={handleViewCartClick}
                  style={{
                    borderRadius: "50px",
                    background: "linear-gradient(135deg, #ee6521, #8a2be2)",
                    color: "#fff",
                    padding: "10px 24px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  View Cart
                </button>
              </div>
            </Modal>



          </div>
        ))
      )}


    </div>
  );
};

export default Favorites;
